var FrontEnd = (function () {
    var initFrontEnd = function () {

    };
    return {
        init: function () {
            initFrontEnd();
        },
    };
})();

document.addEventListener("DOMContentLoaded", function () {
    FrontEnd.init();
});
